import { cn } from '@repo/tailwind-config/tailwind.functions'
import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { DateFormatter } from '@repo/toolkit/date'

import Typography from '../../../../../../packages/ui/components/atoms/typography'
import {
  notificationTypeMapping,
  renderNotificationMessage
} from '../../../lib/types/enums/notifications/notification-type.enum'
import { Notification as NotificationType } from '../../../lib/types/models/notification/notification'
import NotificationLogo from './notification-logo'

interface NotificationProps {
  /**
   * Additional class name
   */
  className?: string

  /**
   * Content of the notification
   */
  notification: NotificationType

  /**
   * Callback when notification is clicked
   */
  onClick: () => void
}

const Notification: React.FC<NotificationProps> = ({ notification, className, onClick }) => {
  const notificationLabel = notificationTypeMapping[notification.type] ?? notification.type
  const notificationMessage = renderNotificationMessage[notification.type]
    ? renderNotificationMessage[notification.type](notification)
    : notification.type

  return (
    <div
      className={cn(
        'flex flex-row items-center justify-between p-2 cursor-pointer transition-colors hover:bg-grey-light-hover/20 gap-4',
        className
      )}
      tabIndex={0}
      onClick={onClick}
    >
      <div className={'flex flex-row items-center gap-3'}>
        <div>
          <NotificationLogo isUnread={!notification.read} />
        </div>
        <Typography variant="label-medium">
          <b>{`${notificationLabel} : `}</b>
          {notificationMessage}
        </Typography>
      </div>
      <div className={'flex flex-row items-center gap-1 select-none'}>
        <Typography variant={'small-medium'} color={tailwindColors.grey.lighter}>
          {DateFormatter.timeSince(notification.createdAt)}
        </Typography>

        {!notification.read && <div className={'w-1.5 h-1.5 rounded-full bg-red-secondary'} />}
      </div>
    </div>
  )
}

export default Notification
